export default __webpack_public_path__ + "static/media/default.12db3d41.jpg";